import { Intervention } from '@/app/components/action-plan/types';
import { getInterventionRiskData, sortInterventions } from '@/utils';
import React from 'react';
import '../../../../dashboard/dashboard-reset.css';
import ActiveInterventionCard from './components/active-intervention-card/active-intervention-card';

type CurrentActionPlanProps = {
  interventions: Intervention[];
  onCompleteIntervention: (intervention: Intervention) => void;
};

function CurrentActionPlan({ interventions, onCompleteIntervention }: CurrentActionPlanProps) {
  const sortedInterventions = interventions.map(getInterventionRiskData).sort(sortInterventions);

  return (
    <main className="dashboard-reset flex-grow">
      <h2 className="section-heading">
        Recommended Actions
      </h2>
      <div className="flex flex-col gap-4">
        {sortedInterventions.map((intervention) => (
          <ActiveInterventionCard
            key={intervention.id}
            intervention={intervention}
            onCompleteIntervention={onCompleteIntervention}
          />
        ))}
      </div>
    </main>
  );
}

export default React.memo(CurrentActionPlan);
